import { findCouncil } from '@curby/shared';
import { Text } from '@mantine/core';
import { IconHomeCheck } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { InfoAlert } from '../alerts';
import { NotEligibleAlert } from './not-eligible-alert';

type AddressCheckProps = {
	council: string | null | undefined;
	postcode: string | null | undefined;
	state: string | null | undefined;
	lat: number | null | undefined;
	lng: number | null | undefined;
};

export const AddressCheck = ({ council, postcode, state, lat, lng }: AddressCheckProps) => {
	const [matchedCouncil, setMatchedCouncil] = useState<string | undefined>(undefined);

	useEffect(() => {
		setMatchedCouncil(findCouncil(council, state, postcode));
	}, [council, postcode, state]);

	if (!(council && state) && !postcode) {
		return null;
	}

	if (matchedCouncil) {
		return (
			<InfoAlert
				title={`Your address is in ${matchedCouncil} and is eligible for kerbside pick-up.`}
				icon={<IconHomeCheck name="info" />}
				// TODO Do we need to show the closest drop off for these users?
			>
				<Text size="sm" fw={400}>
					Please place your bag in the yellow bin. Alternatively you may place your bag at your
					closest drop off point
				</Text>
			</InfoAlert>
		);
	}

	return <NotEligibleAlert lat={lat} lng={lng} />;
};
